import { render, staticRenderFns } from "./BlocoProcon.vue?vue&type=template&id=6a3df3db&scoped=true&"
import script from "./BlocoProcon.vue?vue&type=script&lang=ts&"
export * from "./BlocoProcon.vue?vue&type=script&lang=ts&"
import style0 from "./BlocoProcon.vue?vue&type=style&index=0&id=6a3df3db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3df3db",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VExpandTransition,VRow,VSwitch,VTextField})
